import UnauthorizedPage from '@/components/pages/_shared/UnauthorizedPage';

export default function Error403Page() {
  return <UnauthorizedPage />;
}
